import { format } from 'url';
import { getUserToken } from 'utils/storage'
import { config } from 'config'

type IMethod = 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';
type IResponseType = 'JSON' | 'BLOB' | 'TEXT';

export interface IOptions {
  method: IMethod;
  url: string;
  params?: any;
  contentType?: any;
  responseType?: IResponseType;
}

const getPath = (url: string): string =>
  `${url.match(/(http|https):\/\//i) ? '' : config.apiUrl}${url}`;

const getHeaders = (
  method: IMethod,
  contentType: string,
  data: any
): any => {
  const isFormData = data instanceof FormData;

  return Object.assign(
    getUserToken() ? { 'Authorization': `Bearer ${getUserToken()}` } : {},
    !isFormData ? {
      'Content-Type': contentType || (!!method?.match(/(POST|PUT|PATCH)/) ? 'application/json' : 'text/plain')
    }
      : {}
  );
};

export const requestAPI = async ({ method, url, params, contentType, responseType = 'JSON' }: IOptions) => {

  const headers: any = getHeaders(method, contentType, params);
  let responseStatus: number = 0;
  let path: string = getPath(url);

  (method || '').match(/(GET|DELETE)/) &&
    (path = `${path}${format({ query: params })}`);

  try {
    const result = await fetch(path, {
      method: method,
      headers: headers,
      body: (method || '').match(/(POST|PATCH|PUT)/) && params ?
        params instanceof FormData ?
          params
          : JSON.stringify(params)
        : null,
      mode: 'cors',
      cache: 'no-cache',
      credentials: 'omit'
    }).then(response => {
      responseStatus = response.status;

      return responseStatus === 200 && responseType?.match(/BLOB/) ?
        response.blob()
        : responseType?.match(/TEXT/) ?
          response.text()
          : response.json();
    }).then(data => {
      if (responseStatus >= 200 && responseStatus < 300 && !`${data.result}`?.match(/(FAIL|NONE)/i)) {
        return {
          data,
          status: responseStatus
        };
      } else {
        throw JSON.stringify(data);
      }
    }).catch(error => {
      if (responseStatus == 401) {
        window.location.assign('/')
      }
      throw error;
    });

    return result;
  } catch (error) {
    throw responseStatus ? error : '{"message":"Network Error"}';
  }
};

export const uploadFileAPI = async (
  params: {
    method: IMethod;
    data: any;
    file?: File;
    url?: string;
    apiUrl?: string;
  },
  onLoadStart?: any,
  onProgress?: any
) => {
  const headers: any = getHeaders(
    params.method,
    params.file ? params.file.type : '',
    params.data
  );

  const path: string = getPath(
    params.url || params.apiUrl || ''
  );

  const xhr = new XMLHttpRequest();

  return await new Promise<void>((resolve, reject) => {
    xhr.open(params.method, path, true);

    Object.keys(headers).forEach(key => {
      xhr.setRequestHeader(key, headers[key]);
    });

    xhr.upload.onloadstart = onLoadStart;
    xhr.upload.onprogress = onProgress;
    xhr.onload = () => {
      resolve();
    };
    xhr.onerror = () => {
      reject('Network Error');
    };
    xhr.send(params.file || params.data);

  }).then(() => {
    if (xhr.status >= 200 && xhr.status < 300) {
      return {
        data: xhr.responseText ?
          JSON.parse(xhr.responseText)
          : { result: true },
        status: xhr.status
      };
    } else {
      throw new Error(xhr.responseText);
    }
  }).catch(error => {
    throw error;
  });
};